/**
 * TODO: pridat zpozdena platba
 * @readonly
 * @enum {string}
 */
module.exports = {
    EXPIRED: 'expired',
    ACTIVE: 'active',
    WAITING_FOR_PAYMENT: 'waiting_for_payment',
    CANCEL_AT_PERIOD_END: 'cancel_at_period_end',
};
